import { request } from "./http";

export type SupportTicketSeverity = "low" | "normal" | "high" | "urgent";
export type SupportTicketStatus = "open" | "triaged" | "waiting_user" | "resolved" | "closed";

export type UserSupportTicketSummary = {
  public_id: string;
  status: SupportTicketStatus;
  severity: SupportTicketSeverity;
  source?: string | null;
  subject?: string | null;
  issue_preview?: string | null;
  app_version?: string | null;
  platform?: string | null;
  device_model?: string | null;
  external_issue_provider?: string | null;
  external_issue_key?: string | null;
  external_issue_url?: string | null;
  created_at?: string | null;
  updated_at?: string | null;
  resolved_at?: string | null;
  closed_at?: string | null;
  latest_admin_reply?: string | null;
  user_unread?: number | boolean | null;
  admin_unread?: number | boolean | null;
  last_user_seen_at?: string | null;
  last_admin_seen_at?: string | null;
  last_user_reply_at?: string | null;
  last_admin_reply_at?: string | null;
};

export type UserSupportTicketEvent = {
  id: number;
  event_type: string;
  from_status?: string | null;
  to_status?: string | null;
  note?: string | null;
  created_at?: string | null;
  meta?: any;
};

export type UserSupportTicketDetail = UserSupportTicketSummary & {
  issue_text?: string | null;
  user_public_id?: string | null;
};

export function createSupportTicket(payload: {
  subject: string;
  issue: string;
  severity?: SupportTicketSeverity;
  source?: "mobile" | "web" | "admin" | "api" | "unknown";
  platform?: string;
  appVersion?: string;
  deviceModel?: string;
  bundle?: any;
  logs?: any;
  metadata?: any;
}): Promise<{
  ok: boolean;
  ticket: {
    id: string;
    public_id: string;
    status: SupportTicketStatus;
  };
}> {
  return request("/support/tickets", {
    method: "POST",
    body: payload,
    auth: true,
  });
}

export function listMySupportTickets(status?: SupportTicketStatus): Promise<{
  ok: boolean;
  items: UserSupportTicketSummary[];
}> {
  const qs = status ? `?status=${encodeURIComponent(status)}` : "";
  return request(`/support/tickets${qs}`, { auth: true });
}

export function getMySupportTicket(publicId: string): Promise<{
  ok: boolean;
  ticket: UserSupportTicketDetail;
  events: UserSupportTicketEvent[];
}> {
  return request(`/support/tickets/${encodeURIComponent(publicId)}`, { auth: true });
}

export function replyToMySupportTicket(publicId: string, message: string): Promise<{
  ok: boolean;
  ticket: {
    public_id: string;
    status: SupportTicketStatus;
  };
}> {
  return request(`/support/tickets/${encodeURIComponent(publicId)}/reply`, {
    method: "POST",
    body: { message },
    auth: true,
  });
}

export function markMySupportTicketSeen(publicId: string): Promise<{
  ok: boolean;
  ticket: UserSupportTicketDetail;
}> {
  return request(`/support/tickets/${encodeURIComponent(publicId)}/seen`, {
    method: "POST",
    auth: true,
  });
}
